export const badge = {
  badge: {
    colorScheme: {
      light: {
        danger: {
          background: '{red.500}',
        },
        borderRadius: '10px',
        minWidth: 'revert',
        dotSize: '1.5rem',
      },
    },
  },
};
